const IMAGE_EXTENSIONS = new Set(['jpg', 'jpeg', 'png', 'gif', 'webp'])

export const getPathExtension = (path?: string): string => {
  if (!path) return ''
  const pathname = path.split('?')[0]
  const dotIndex = pathname.lastIndexOf('.')
  if (dotIndex <= 0) return ''
  return pathname.slice(dotIndex + 1).toLowerCase()
}

export const isImagePath = (path?: string): boolean =>
  IMAGE_EXTENSIONS.has(getPathExtension(path))

export const normalizeFileExtension = (extension?: string, path?: string): string => {
  const fromField = extension?.trim()
  const ext = fromField || getPathExtension(path)
  if (!ext) return ''
  const normalized = ext.startsWith('.') ? ext.slice(1) : ext
  return `.${normalized.toLowerCase()}`
}

export const toFileNameSlug = (value: string): string =>
  value.trim().toLowerCase().split(' ').filter(Boolean).join('-')

export const getFileNameFromPath = (path?: string): string => {
  if (!path?.trim()) return ''

  const pathname = path.split('?')[0]
  const segments = pathname.split('/').filter(Boolean)
  const lastSegment = segments[segments.length - 1] ?? ''

  try {
    return decodeURIComponent(lastSegment)
  } catch {
    return lastSegment
  }
}
